/**
 * MCP Recién Nacidos — decoración: fragmentos de código gateando por la
 * parte baja de la pantalla, rápidos y con rebote (@keyframes mcp-crawl en
 * mcp-newborns.css) -- contraste deliberado con el paso lento y arrítmico
 * del Cementerio (mcp-cemetery.js).
 *
 * Mismo contrato que el Cementerio: capa 100% decorativa sobre un <div>
 * vacío en el HTML servido (newborns.blade.php); sin JS no pasa nada, y
 * con prefers-reduced-motion no se crea ni un solo fragmento -- la lista
 * real de altas vive fuera de esta capa, en .mcp-newborns__content, y no
 * depende de este script para nada.
 */
const FRAGMENTS = ['{}', '();', 'null', 'let', '=>'];
const COUNT = 10;

function boot(field) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const frag = document.createDocumentFragment();
    for (let i = 0; i < COUNT; i++) {
        const el = document.createElement('span');
        el.className = 'mcp-crawler';
        el.textContent = FRAGMENTS[i % FRAGMENTS.length];
        el.setAttribute('aria-hidden', 'true');
        el.style.bottom = (Math.random() * 70).toFixed(0) + '%';
        el.style.animationDelay = (Math.random() * 6).toFixed(2) + 's';
        el.style.animationDuration = (6 + Math.random() * 5).toFixed(2) + 's';
        frag.appendChild(el);
    }
    field.appendChild(frag);
    field.classList.add('is-animated');
}

document.querySelectorAll('[data-mcp-newborns-field]').forEach(boot);
